export const TenantReviewsSpecificCountries = [{ name: 'Italy' }];
